import React from "react";
import DashboardHome from "../../../components/Dashboard/Admin/DashboardHome";

const Admin = () => {
  return (
    <div className="font-sans">
      {/* Use <main> for the primary content of the page */}
      <main className="mx-auto max-w-7xl px-6 py-10 sm:px-8 lg:px-10">
        <DashboardHome />
      </main>
    </div>
  );
};

export default Admin;